import { from, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';

// eslint-disable-next-line import/prefer-default-export
export const wrapAutosuggestForLegacyUI = (autosuggestPromise) => (payload) => {
   return from(
      autosuggestPromise(payload),
   ).pipe(
      first(),
      map(({ data }) => {
         let result = data?.data || [];

         result = result?.map((item) => (
            {
               ...item,
               label: item?.name,
               value: item?.id,
            }
         ));

         return {
            result,
            totalSize: data?.totalSize,
            // true when the backend capped the count (reads as "1,000+" in the pager)
            totalSizeCapped: !!data?.totalSizeCapped,
         };
      }),
      catchError((err) => {
         console.log(err);
         return of({});
      }),
   );
};
